import { InstanceTypeOf } from '@/type-utils';
import { errorFactory } from '@/utils/error-utils';

export const { CannotMergeCartsError } = errorFactory('CannotMergeCartsError');

/** Error to use when there was an error merging carts in AWS. */
export type CannotMergeCartsError = InstanceTypeOf<
  typeof CannotMergeCartsError
>;
